var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotspot",style:({ left: _vm.percentagePosition, width: _vm.percentageWidth })})
}
var staticRenderFns = []

export { render, staticRenderFns }